<template>
  <div class="invite-wrap">
    <back-button />
    <div class="invite-main">
      <!-- 邀请总数 -->
      <div class="invite-header">
        <div class="invite-icon">
          <img src="@/assets/img/invite-icon.png" alt="邀请icon" />
        </div>
        <div class="invite-tip">
          温馨提示：大赛期间，邀请好友注册并完成首次答题，每成功邀请1人完赛即可获得1个现金红包，单人最多可获10个。每日红包数量有限，先到先得，快来邀友答题赢好礼吧！
        </div>
      </div>
      <div class="invite-content-wrap">
        <div class="invite-btn-wrap">
          <div class="invite-total">
            累计邀请
            <span class="highlight">{{ invitedFriends.length }}</span>
            位好友
          </div>
          <van-button
            class="invite-btn"
            block
            type="info"
            :disabled="invitedFriends.length >= maxInvite"
            @click="captureCard"
          >
            邀请好友
          </van-button>
        </div>
        <div v-if="invitedFriends.length < maxInvite" class="invite-remain">
          还可邀请
          <span class="remain-num">{{
            maxInvite - invitedFriends.length
          }}</span>
          位好友，每邀请1人可获得1次抽奖机会
        </div>
        <div v-else class="invite-remain limit">
          您已达到邀请上限（{{ maxInvite }}人），感谢支持！
        </div>
        <div class="group-section">
          <div class="section-title">我邀请的好友</div>
          <div v-if="friendGroups.length === 0" class="group-empty">
            暂无好友，快去邀请吧~
          </div>
          <div
            v-for="(group, gIdx) in friendGroups"
            :key="gIdx"
            class="group-card"
          >
            <div class="group-desc">
              {{ group.nicknameText }} 已通过您的邀请参赛
            </div>
            <div class="group-item">
              <div class="group-members">
                <div
                  v-for="(member, mIdx) in group.members"
                  :key="mIdx"
                  class="member-item"
                >
                  <img :src="member.avatar" class="member-avatar" />
                </div>
              </div>
              <!-- 抽奖按钮 -->
              <div class="group-action">
                <van-button
                  v-if="!group.drawn"
                  class="draw-btn"
                  round
                  type="danger"
                  :disabled="!group.canDraw"
                  @click="handleGroupDraw(gIdx)"
                >
                  抽奖
                </van-button>
                <span v-else class="drawn-tag">已抽奖</span>
              </div>
            </div>
          </div>
          <div class="friend_top_tip">仅展示邀请完赛的前10位好友</div>
        </div>
      </div>
      <!-- 红包奖励明细 -->
      <div class="reward-section">
        <div class="reward-title">
          <img src="@/assets/img/invite-reward-icon.png" alt="奖励明细" />
        </div>
        <div class="reward-list">
          <div
            v-for="(item, index) in rewardGroups"
            :key="index"
            class="reward-item"
          >
            <div class="reward-left">
              <span class="reward-desc">邀请{{ item.nicknameText }}</span>
              <span class="reward-time">{{ item.time }}</span>
            </div>
            <div class="reward-right">
              <span class="reward-amount">{{ item.money }}元</span>
            </div>
          </div>
          <div v-if="rewardGroups.length === 0" class="reward-empty">
            暂无红包记录
          </div>
        </div>
      </div>
    </div>

    <!-- 隐藏卡片用于 html2canvas 截图 -->
    <div id="inviteCapture" ref="inviteCapture">
      <div class="capture-card">
        <div class="capture-top mt-20">
          <img class="capture-label" src="@/assets/img/label-icon.png" alt="" />
        </div>
        <div class="capture-top">
          <img
            class="capture-label w-216"
            src="@/assets/img/time-icon.png"
            alt=""
          />
        </div>
        <div class="capture-top">
          <img
            class="capture-label w-262"
            src="@/assets/img/tip-bg.png"
            alt=""
          />
        </div>
        <div class="capture-user">
          <div class="flex-center">
            <img :src="userAvatar" class="capture-avatar" alt="" />
            <div>
              <div class="capture-name">{{ userName }}</div>
              <div class="capture-tip">已邀请好友</div>
            </div>
          </div>
          <div class="capture-info">
            <span class="capture-count-f28"> {{ invitedFriends.length }}</span>
            <span class="capture-count"> 位 </span>
          </div>
        </div>
        <div class="invite-tips">
          {{
            userName
          }}邀您参与《2026年山西省公众科学素质网络知识竞赛》答题活动，赢取现金红包，快来参加吧！
        </div>
        <div class="capture-qr-wrap">
          <img class="capture-qr" :src="qrCodeDataUrl" alt="" />
          <div class="capture-qr-tip">
            长按保存图片至相册，<br />扫描二维码参与答题活动
          </div>
        </div>
      </div>
    </div>

    <!-- 截图预览弹窗 -->
    <van-dialog
      v-model="showImageDialog"
      class="image-dialog"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="image-dialog-content">
        <img class="image-preview" :src="captureImage" alt="" />
        <div class="image-tip">长按图片保存到相册</div>
        <img
          class="image-close"
          src="@/assets/img/close-btn.png"
          @click="showImageDialog = false"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import BackButton from "@/components/BackButton.vue";
import html2canvas from "html2canvas";
import QRCode from "qrcode";

const GROUP_SIZE = 1;

export default {
  name: "Invite",
  components: { BackButton },
  data() {
    return {
      invitedFriends: [],
      maxInvite: 10,
      showImageDialog: false,
      captureImage: "",
      qrCodeDataUrl: "",
    };
  },
  computed: {
    // 将好友列表每3个一组
    friendGroups() {
      const groups = [];
      for (let i = 0; i < this.invitedFriends.length; i += GROUP_SIZE) {
        const members = this.invitedFriends.slice(i, i + GROUP_SIZE);
        // 全组 ident 都为空 => 未抽奖；任意一个 ident 有值 => 已抽奖
        const allIdentEmpty = members.every((m) => !m.ident);
        const anyIdentFilled = members.some((m) => !!m.ident);
        const isFull = members.length === GROUP_SIZE;
        // 取第一个有值的 money / create_time
        const rewardMember = members.find((m) => Number(m.money)) || {};
        groups.push({
          members,
          count: members.length,
          isFull,
          drawn: anyIdentFilled,
          canDraw: isFull && allIdentEmpty,
          money: rewardMember.money || 0,
          create_time: rewardMember.create_time || 0,
          nicknameText: members.map((m) => m.nickname).join("、"),
        });
      }
      return groups.reverse();
    },
    // 筛选 money !== 0 的分组作为红包奖励明细
    rewardGroups() {
      return this.friendGroups
        .filter((g) => Number(g.money) !== 0)
        .map((g) => ({
          nicknameText: g.nicknameText,
          money: Number(g.money) / 100,
          time: this.formatTime(g.create_time),
        }));
    },
    user() {
      return this.$store.state.user?.user || {};
    },
    userAvatar() {
      return this.user.avatar || require("@/assets/default-avatar.png");
    },
    userName() {
      return this.user.nickname || this.user.name || "科学达人";
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const res = await this.$axios.post("/user/getInviteUser");
        if (res.data) {
          this.invitedFriends = res.data.list || [];
        }
      } catch (error) {
        console.log(error);
      }
      this.generateQRCode();
    },
    generateQRCode() {
      const userId = this.user.id || "default";
      const shareUrl = `${window.location.origin}/sxcompetition/api?ident=${userId}`;
      QRCode.toDataURL(shareUrl, {
        width: 240,
        margin: 2,
        color: { dark: "#000000", light: "#ffffff" },
      })
        .then((url) => {
          this.qrCodeDataUrl = url;
        })
        .catch(() => {
          this.qrCodeDataUrl = "";
        });
    },
    formatTime(timestamp) {
      if (!timestamp) return "";
      const d = new Date(
        String(timestamp).length <= 10 ? timestamp * 1000 : Number(timestamp)
      );
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    // html2canvas 截图
    async captureCard() {
      this.$toast.loading({
        message: "正在生成图片...",
        forbidClick: true,
        duration: 0,
      });
      try {
        const canvas = await html2canvas(this.$refs.inviteCapture, {
          scale: 2,
          useCORS: true,
          backgroundColor: null,
          logging: false,
        });
        this.captureImage = canvas.toDataURL("image/png");
        this.$toast.clear();
        this.showImageDialog = true;
      } catch (e) {
        this.$toast.clear();
        this.$toast.fail("图片生成失败");
      }
    },
    async handleGroupDraw(groupIdx) {
      const group = this.friendGroups[groupIdx];
      if (!group.canDraw) return;
      try {
        const res = await this.$axios.post("/Redpackets/drawAward", {
          id_arr: group.members.map((m) => m.id),
        });
        if (res.data?.money && res.data?.money != 0) {
          this.$dialog
            .alert({
              title: `恭喜抽中 ${Number(res.data.money) / 100} 元红包！`,
              message: `说明：中奖红包已通过微信消息通知发送给您，请及时前往领取`,
              confirmButtonText: "开心收下",
            })
            .then(() => {
              this.loadData();
            });
        } else {
          this.$dialog
            .alert({
              title: "提示",
              message: `今日红包已抢完，明天早点来吧~`,
              confirmButtonText: "确定",
            })
            .then(() => {
              this.loadData();
            });
        }
      } catch (error) {
        // 模拟抽奖结果
        this.$dialog
          .alert({
            title: "提示",
            message: `今日红包已抢完，明天早点来吧~`,
            confirmButtonText: "确定",
          })
          .then(() => {
            this.loadData();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.invite-wrap {
  box-sizing: border-box;
  height: 100vh;
  overflow: hidden;
  @include plain-bg;
  @include safe-area-bottom("20px");

  .invite-main {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    padding: 40px 16px 20px;
    overflow-y: auto;
  }
}

// 头部邀请统计
.invite-header {
  padding: 20px 0 10px;
  text-align: center;

  .invite-icon {
    img {
      width: 187px;
    }
  }
  .invite-tip {
    padding: 8px 11px;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 500;
    line-height: 15px;
    color: #fff;
    background: rgba(35, 123, 224, 0.5);
    border-radius: 30px;
  }

  .invite-chance {
    font-size: 14px;
    color: $gray-color;

    .highlight {
      font-weight: 600;
      color: $font-orange-color;
    }
  }
}
.invite-content-wrap {
  padding: 12px 18px 12px;
  background: #e3eefb;
  border-radius: 18px;
  .invite-btn-wrap {
    display: flex;
    justify-content: space-between;
    padding-bottom: 8px;
    border-bottom: 1px dotted #d2d2d2;
    .invite-total {
      margin-bottom: 8px;
      font-size: 12px;
      font-weight: 400;
      color: $black;

      .highlight {
        font-size: 28px;
        color: $font-red-color;
      }
    }
    .invite-btn {
      width: 116px;
      font-size: 14px;
      font-weight: 600;
      color: #1339dc;
      letter-spacing: 2px;
      background: #fcc416;
      border: none;
      border-radius: 5px;

      &.van-button--disabled {
        color: #666;
        background: #ccc;
        opacity: 0.5;
      }
    }
  }
  .invite-remain {
    margin-top: 10px;
    font-size: 12px;
    color: $font-orange-color;
    text-align: center;

    .remain-num {
      padding: 0 2px;
      font-size: 16px;
      font-weight: 700;
      color: $font-red-color;
    }

    &.limit {
      color: $gray-color;
    }
  }
}
// 邀请按钮

// 好友分组
.group-section {
  margin-top: 16px;
  .section-title {
    padding-left: 4px;
    margin-bottom: 12px;
    font-size: 16px;
    font-weight: 600;
    color: $black;
  }

  .group-empty {
    padding: 32px 0;
    font-size: 14px;
    color: $gray-color;
    text-align: center;
  }

  .friend_top_tip {
    padding: 6px 0;
    font-size: 12px;
    color: $gray-color;
    text-align: center;
  }

  .group-card {
    padding: 16px;
    margin-bottom: 12px;
    background: #f6f6dd;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    .group-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .group-members {
    display: flex;
    gap: 8px;
    justify-content: center;

    .member-item {
      display: flex;
      flex-direction: column;
      gap: 6px;
      align-items: center;
    }

    .member-avatar {
      width: 28px;
      height: 28px;
      border: 2px solid #f0f0f0;
      border-radius: 50%;
      object-fit: cover;
    }

    .member-name {
      max-width: 60px;
      overflow: hidden;
      font-size: 12px;
      color: #666;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .group-desc {
    margin-bottom: 12px;
    font-size: 13px;
    color: $gray-color;
    text-align: center;
  }

  .group-action {
    .draw-btn {
      width: 88px;
      height: 28px;
      font-size: 15px;
      font-weight: 600;
      background: #f2323f;
      border: none;
      border-radius: 18px;

      &.van-button--disabled {
        background: #ccc;
        opacity: 0.5;
      }
    }

    .drawn-tag {
      display: inline-block;
      padding: 6px 24px;
      font-size: 15px;
      color: $gray-color;
      background: #f5f5f5;
      border-radius: 18px;
    }
  }
}

// 红包奖励明细
.reward-section {
  margin-top: 10px;

  .reward-title {
    text-align: center;
    img {
      width: 173px;
    }
  }

  .reward-list {
    padding: 12px;
    background: #e2ebf9;
    border-radius: 18px;
    .reward-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 8px;
      background: #f6f6dd;
      border-bottom: 1px solid #f5f5f5;
      border-radius: 8px;

      &:last-child {
        border-bottom: none;
      }
    }

    .reward-left {
      display: flex;
      flex: 1;
      flex-direction: column;

      .reward-desc {
        font-size: 14px;
        font-weight: 500;
        color: #333;
      }

      .reward-time {
        margin-top: 4px;
        font-size: 11px;
        color: $gray-color;
      }
    }

    .reward-right {
      .reward-amount {
        font-size: 18px;
        font-weight: 700;
        color: $font-red-color;
      }
    }

    .reward-empty {
      padding: 24px 0;
      font-size: 14px;
      color: $gray-color;
      text-align: center;
    }
  }
}

// ============ 隐藏截图区域 ============
#inviteCapture {
  position: fixed;
  top: 0;
  left: -9999px;
  z-index: -1;
}

.capture-card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 540px;
  padding-bottom: 40px;
  color: $white;
  text-align: center;
  background: url("~@/assets/img/plain-bg.png") no-repeat center -40px;
  background-size: 100%;

  .capture-top {
    &.mt-20 {
      padding-top: 40px;
    }
    .capture-label {
      display: block;
      width: 100%;
      &.w-216 {
        width: 432px;
      }
      &.w-262 {
        width: 524px;
        margin: -20px 0;
      }
    }
  }

  .capture-user {
    display: flex;
    flex: 1;
    flex-direction: row;
    gap: 14px;
    align-items: center;
    justify-content: space-between;
    width: 620px;
    padding: 32px 40px;
    color: #0441e0;
    background: url("~@/assets/img/num-bg.png") no-repeat center / cover;
    background-size: 100% 100%;
    border-radius: 12px;
    .flex-center {
      display: flex;
      align-items: center;
    }
    .capture-avatar {
      flex-shrink: 0;
      width: 112px;
      height: 112px;
      margin-right: 30px;
      border: 4px solid rgba(255, 255, 255, 0.4);
      border-radius: 50%;
      object-fit: cover;
    }

    .ccapture-info {
      text-align: left;
    }

    .capture-name {
      font-size: 32px;
      font-weight: 600;
      text-align: left;
    }
    .capture-tip {
      margin-top: 30px;
      font-size: 30px;
      color: #716950;
    }
    .capture-count-f28 {
      font-size: 92px;
      font-weight: 600;
    }
    .capture-count {
      margin-top: 4px;
      font-size: 28px;
    }
  }
  .invite-tips {
    width: 770px;
    margin: 26px 0;
    font-size: 28px;
    font-weight: 600;
    line-height: 36px;
    color: #fff;
    text-align: center;
  }

  .capture-qr-wrap {
    display: flex;
    gap: 14px;
    align-items: center;
    width: 600px;
    height: 208px;
    padding: 20px 28px;
    background: url("~@/assets/img/code-bg.png") no-repeat center;
    background-size: 100% 100%;
    border-radius: 12px;
    .capture-qr {
      box-sizing: border-box;
      flex-shrink: 0;
      width: 174px;
      height: 174px;
      padding: 8px;
      margin-right: 30px;
      background: #fff;
      border-radius: 6px;
    }

    .capture-qr-tip {
      font-size: 30px;
      line-height: 1.9;
      color: rgba(255, 255, 255, 0.9);
      text-align: center;
    }
  }
}

// ============ 截图预览弹窗 ============
.image-dialog {
  width: 350px;
  overflow: visible;
  background: transparent;
  border-radius: 12px;

  .image-dialog-content {
    position: relative;
    padding: 10px;
    text-align: center;
  }

  .image-preview {
    display: block;
    width: 100%;
    border-radius: 12px;
  }

  .image-tip {
    margin-top: 12px;
    font-size: 13px;
    color: $white;
    letter-spacing: 1px;
  }

  .image-close {
    position: absolute;
    bottom: -42px;
    left: 50%;
    width: 32px;
    height: 32px;
    transform: translateX(-50%);
  }
}
</style>
